import { getListBaseUrl, getListUrl } from '@components/UserList/listApiUrls';
import { ProductListV2 } from '@lib/types/api/ProductListV2';

const DEFAULT_NAMESPACE = 'assetstore';
const DEFAULT_SOURCE_SYSTEM = 'genesis';

export const createList = async (
  name: string,
  visibility: string,
  organizationId?: string
): Promise<ProductListV2> => {
  const payload = {
    name,
    visibility,
  };
  const response = await fetch(getListBaseUrl(organizationId), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error('Failed to create list');
  }

  return response.json();
};

export const addItemToList = async (
  listId: string,
  productId: string,
  organizationId?: string
): Promise<void> => {
  const response = await fetch(`${getListUrl(listId, organizationId)}/items`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      namespace: DEFAULT_NAMESPACE,
      productId,
      sourceSystem: DEFAULT_SOURCE_SYSTEM,
    }),
  });

  if (!response.ok) {
    throw new Error('Failed to add item to list');
  }
};

export const removeItemFromList = async (
  listId: string,
  productId: string,
  organizationId?: string
): Promise<void> => {
  const response = await fetch(
    `${getListUrl(listId, organizationId)}/items/${DEFAULT_NAMESPACE}/${productId}`,
    { method: 'DELETE' }
  );

  if (!response.ok && response.status !== 204) {
    throw new Error('Failed to remove item from list');
  }
};

export const setFavoriteList = async (listId: string): Promise<void> => {
  const response = await fetch(`/api/lists/${listId}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ isFavorites: true }),
  });

  if (!response.ok) {
    throw new Error('Failed to set favorite list');
  }
};
